import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/CategoryBreakdown/BarBreakdown.styl'
import cn from 'classnames'
import { Bar } from 'components/features/pfm/CategoryBreakdown/Bar'
import { StatusType } from 'interfaces'
import Tooltip from 'components/features/pfm/Tooltip/Tooltip'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { getBarLength } from 'helpers/categoriesHelpers'

type BarBreakdownProps = {
  amount: number
  projected: number | null
  max: number
  theme: StatusType
}

export const BarBreakdown: FC<BarBreakdownProps> = (props) => {
  const {
    amount,
    projected,
    max,
    theme,
  } = props

  const tooltipLeft = useMemo(() => {
    if (!projected) {
      return null
    }
    const diff = projected - amount
    return getBarLength(amount + diff / 2, max)
  }, [projected, amount, max])

  const className = cn(styles.barBreakdown, styles[theme])
  return (
    <div className={ className }>
      { projected && (
        <>
          <Bar amount={ projected } max={ max } className={ cn(styles.line, styles.projected) } />
          <div className={ styles.tooltip } style={{ '--left': `${ tooltipLeft }%` } as {}}>
            <Tooltip theme={ theme } light>
              projected: { formatUSCurrency(projected) }
            </Tooltip>
          </div>
        </>
      )}
      <Bar amount={ amount } max={ max } className={ cn(styles.line, styles.amount) } />
    </div>
  )
}
